import { render, staticRenderFns } from "./date-block-new.html?vue&type=template&id=ccee68b2&scoped=true&"
import script from "./date-block-new.js?vue&type=script&lang=js&"
export * from "./date-block-new.js?vue&type=script&lang=js&"
import style0 from "./date-block-new.scss?vue&type=style&index=0&id=ccee68b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccee68b2",
  null
  
)

export default component.exports